import React, { ComponentProps } from "react";

import EnvironmentConfiguration from "../../../../constants/EnvironmentConfiguration";
import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import DesktopDateSelector from "../Components/DesktopDateSelector";
import MobileDateSelector from "../Components/MobileDateSelector";
import ScheduleSlotSelector from "../Components/ScheduleSlotSelector";
import ScheduleSlotTimeLocaleSelector from "../Components/ScheduleSlotTimeLocaleSelector";
import { IScheduleSlotSelectorProps } from "../Components/SchedulingStep";

const AppContextScheduleSlotSelector: React.FC<Omit<ComponentProps<typeof ScheduleSlotSelector>, "schedule">> =
  AppContextValueProvider<
    Pick<ComponentProps<typeof ScheduleSlotSelector>, "schedule">,
    ComponentProps<typeof ScheduleSlotSelector>
  >({
    Component: ScheduleSlotSelector,
    map: ({ bookingController }) => {
      if (!bookingController?.selected) throw new Error("Booking schedule is required.");
      return { schedule: bookingController.selected.schedule };
    }
  });

const DynamicScheduleSlotSelector: React.FC<IScheduleSlotSelectorProps> = props => (
  <AppContextScheduleSlotSelector
    {...props}
    slotSelectionMaskedMinutes={EnvironmentConfiguration.calendarAllowedPaddingMinutes}
    refreshIntervalMs={20000}
    timeSelectorCutOffs={{ morning: 12, afternoon: 17 }}
    DesktopDateSelector={DesktopDateSelector}
    MobileDateSelector={MobileDateSelector}
    TimeLocaleSelector={ScheduleSlotTimeLocaleSelector}
  />
);

export default DynamicScheduleSlotSelector;
